<script lang="ts">
	import loaderIcon from "@core/assets/icons/loader.svg?raw";
	import Icon from "./common/Icon.svelte";
</script>

<div class="h-[calc(100vh-4rem)]"></div>
<div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
	<Icon icon={loaderIcon} class="size-30 animate-[spin_1s_steps(8,_jump-end)_infinite_reverse] text-fcrdarkgray" />
</div>
